export default "__VITE_ASSET__fnpARO0O__"